import { EntityService } from 'src/service/EntityService';

export class GoogleService extends EntityService {

  static entity = 'iam-common/oauth2/google/google-doc';

  // Tạo agreement trống
  static createEmpty(): Promise<any> {
    return this.axios.post(`iam-agreement/create/draft`).then(res => res.data);
  }

  // Lấy chi tiết agreement
  static getDetail(agreementId: string): Promise<any> {
    return this.axios.get(`${this.entity}/${agreementId}`).then(res => res.data);
  }

  // Cập nhật agreement
  static update(agreementId: string, data: any): Promise<any> {
    return this.axios.put(`${this.entity}/${agreementId}`, data).then(res => res.data);
  }

  static getList(params?: any): Promise<any> {
    return this.axios.get(`${this.entity}`, { params }).then(res => res.data);
  }

  // Chuyển agreement sang thùng rác (xóa mềm)
  static moveToTrash(agreementId: string): Promise<any> {
    return this.axios.put(`iam-common/agreement/agreements/${agreementId}/trash`).then(res => res.data);
  }

  // Khôi phục agreement từ thùng rác
  static restore(agreementId: string): Promise<any> {
    return this.axios.put(`${this.entity}/${agreementId}/restore`, {}).then(res => res.data);
  }

  // Lấy danh sách agreements với lazyLoadEvent (chuẩn bảng dự án)
  static async getListLazy(lazyLoadEvent: any, extraParams?: any): Promise<any> {
    try {
      // Gửi lazyLoadEvent như query parameters với GET method
      return await this.axios.get(`${this.entity}`, { params: lazyLoadEvent }).then(res => res.data);
    } catch (e) {
      return { success: 'N', data: [], totalRecords: 0, error: 'FETCH_ERROR' };
    }
  }

  static uploadFile(file: File, agreementId?: string, isMainFile?: 'Y' | 'N'): Promise<any> {
    const formData = new FormData();
    formData.append('contentFile', file);
    if (agreementId) formData.append('agreementId', agreementId);
    if (isMainFile) formData.append('isMainFile', isMainFile);
    return this.axios.post(`${this.entity}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
  }

  static saveSignaturePositions(agreementId: string, signatureData: any): Promise<any> {    // Use update Agreement service instead of save SignaturePositions
    return this.axios.put(`iam-common/agreement/agreements/${agreementId}`, signatureData).then(res => res.data);
  }

  // Mở quyền cho agreement (tất cả files hoặc file cụ thể)
  static openDocument(agreementId: string, options?: { fileId?: string; role?: string; type?: string }): Promise<any> {
    const params = {
      role: options?.role || 'writer',
      type: options?.type || 'anyone',
    };
    return this.axios.put(`${this.entity}/${options?.fileId}/permission/open`, params).then(res => res.data);
  }

  // Mở quyền editor cho file cụ thể
  static openEditor(agreementId: string, fileId: string): Promise<any> {
    return this.openDocument(agreementId, { fileId, role: 'writer', type: 'anyone' });
  }

  // Mở quyền viewer cho file cụ thể
  static openAnyoneView(agreementId: string, fileId: string): Promise<any> {
    return this.openDocument(agreementId, { fileId });
  }

  // Đóng quyền cho agreement (tất cả files hoặc file cụ thể)
  static closeDocument(agreementId: string, options?: { fileId?: string }): Promise<any> {
    const params = {
      ...(options?.fileId && { fileId: options.fileId })
    };
    return this.axios.put(`${this.entity}/${agreementId}/permission/close`, params).then(res => res.data);
  }

  // Đóng quyền editor cho file cụ thể
  static closeEditor(agreementId: string, fileId: string): Promise<any> {
    return this.closeDocument(agreementId, { fileId });
  }

  static deleteFile(agreementId: string, fileId: string): Promise<any> {
    return this.axios.delete(`iam-common/agreement/agreements/${agreementId}/contents/${fileId}`).then(res => res.data);
  }

  static generateAgreementCode(agreementType: string): Promise<any> {
    return this.axios.get(`${this.entity}/code`, { params: { agreementType } }).then(res => res.data);
  }
}